// @core/api/endpoints/workflow/get_pipeline_version.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineVersionResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get pipeline version
 * Retrieves a specific pipeline version including all nodes, connections, and canvas settings.
 */
export async function GetPipelineVersion(
  version_id: string,
  options?: RequestOptions
): Promise<PipelineVersionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/versions/:version_id`;
  requestPath = requestPath.replace(':version_id', encodeURIComponent(version_id));
  const requestOptions = options;
  return client.get<PipelineVersionResponse>(requestPath, { ...requestOptions });
}
